import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import styled from 'styled-components';
import { MedicineBoxOutlined, ScissorOutlined, ExperimentOutlined, RestOutlined } from '@ant-design/icons';

const ServicesContainer = styled.div`
  padding: 4rem 0;
  background: #f8f9fa;
`;

const SectionTitle = styled.h2`
  text-align: center;
  margin-bottom: 3rem;
  font-weight: bold;
`;

const ServiceCard = styled(Card)`
  border: none;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-10px);
  }
`;

const IconWrapper = styled.div`
  font-size: 3rem;
  margin-bottom: 1rem;
  text-align: center;
  color: #007bff;
`;

const services = [
  {
    icon: <MedicineBoxOutlined />,
    title: 'Diagnozowanie',
    description: 'Precyzyjna diagnostyka problemów skóry głowy i włosów.',
  },
  {
    icon: <ScissorOutlined />,
    title: 'Terapie',
    description: 'Skuteczne terapie hamujące wypadanie włosów i inne schorzenia.',
  },
  {
    icon: <ExperimentOutlined />,
    title: 'Stymulacja',
    description: 'Zabiegi stymulujące wzrost i regenerację włosów.',
  },
  {
    icon: <RestOutlined />,
    title: 'Pielęgnacja',
    description: 'Profesjonalna pielęgnacja i dobór odpowiednich kosmetyków.',
  },
];

export default function Services() {
  return (
    <ServicesContainer>
      <div className="container">
        <SectionTitle>Nasze Usługi</SectionTitle>
        <Row>
          {services.map((service, index) => (
            <Col md={6} lg={3} key={index} className="mb-4">
              <ServiceCard>
                <Card.Body>
                  <IconWrapper>{service.icon}</IconWrapper>
                  <Card.Title className="text-center">{service.title}</Card.Title>
                  <Card.Text className="text-center">{service.description}</Card.Text>
                </Card.Body>
              </ServiceCard>
            </Col>
          ))}
        </Row>
      </div>
    </ServicesContainer>
  );
}
